<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { CPAppOverlay } from '~/portal/components/base'
import { CPAppUpdateDialog } from '~/portal/components/layout'
import { LApp } from '~/portal/layouts'
import { useAppOverlayStore } from '~/portal/stores'

const appOverlayStore = useAppOverlayStore()
const { isVisible, isLoading, title, message, progress } =
	storeToRefs(appOverlayStore)
</script>

<template>
  <CPAppUpdateDialog />
  <LApp>
    <RouterView />
  </LApp>
  <CPAppOverlay
    v-model="isVisible"
    :loading="isLoading"
    :title="title"
    :message="message"
    :progress="progress"
  />
</template>

<style scoped lang="scss">
//
</style>
